export default {
  awiAdmin: 'AWI Administrator',
  distAdmin: 'District Administrator',
  doeAdmin: 'DOE Administrator',
  doeUser: 'DOE User',
  elcAdmin: 'ELC Administrator',
  elcUser: 'ELC User',
  gceReviewer: 'GCE Reviewer',
  rcmaAdmin: 'RCMA Administrator',
  provider: 'VPK Provider',
  arrpAdmin: 'ARRP Administrator',
  arrpAnalyst: 'ARRP Analyst',
  arrpViewer: 'ARRP Viewer'
}
